import type { FC } from 'react'
import { alpha, Stack, Typography, useTheme } from '@mui/material'

interface SmartImportFileInfoProps {
  fileName: string
  importType: string
}

const SmartImportFileInfo: FC<SmartImportFileInfoProps> = ({ fileName, importType }) => {
  const theme = useTheme()

  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        px: 2,
        py: 1,
        borderRadius: 2,
        backgroundColor: alpha(theme.palette.background.paper, 0.8),
        border: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Typography variant="caption" color="text.secondary">
        {importType}
      </Typography>
      <Typography variant="caption" color="text.disabled">
        •
      </Typography>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{
          maxWidth: 200,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {fileName}
      </Typography>
    </Stack>
  )
}

export default SmartImportFileInfo
